import React, { Component } from 'react';

import { Run, RuleRunner } from '../Validation/RuleRunner'
import { selectedNegativeNumber, requiredWithSelection } from '../Validation/Rules';
import Config from "../../config";


const fieldValidations = [
  RuleRunner("selectedSoftware", "Le choix d'un logiciel", selectedNegativeNumber),
  RuleRunner("softwareOther", "Le nom du logiciel", requiredWithSelection("selectedSoftware", 6)),
];

export default class SoftwareChoice extends Component {

  constructor(props) {
    super(props);

    this.state = {
      softwares: props.softwares,
      selectedSoftware: props.selectedSoftware,
      softwareOther: props.softwareOther,
      softwareWillChange: props.softwareWillChange,
      softwareHasChanged: props.softwareHasChanged,
      softwareOtherFuture : props.softwareOtherFuture,
      displayOtherField: false,
      displayOtherFutureField: false,
      validationErrors: {},
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.displayOtherField(this.state.selectedSoftware);
    this.displayOtherFutureField(this.state.softwareWillChange);
  }

  getObject() {
    return this.state;
  }

  handleChange(event) {
    const name = event.target.name;

    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }
  
    // Update the businessHour object
    //responsibles[index][key] = value;
    this.setState({
      [name]: value
    });

    // Determine if we display or note the other field
    if (name == "selectedSoftware") {
      this.displayOtherField(value);
    }
    else if (name == "softwareWillChange" ){
      this.displayOtherFutureField(value);
    }
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    var errors = Run(this.state, fieldValidations);

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  renderSoftwareView(soft) {
    return (
      <label className="radio-box" key={soft.id}>
        <input type="radio" name="selectedSoftware" 
          value={soft.id} 
          className="radio-box-button" 
          defaultChecked={soft.id == this.state.selectedSoftware} 
          onChange={this.handleChange} 
        />
        <span className={"radio-box-label radio-box-label-program-"+Config.program.style}>{soft.name}</span>
      </label>
    );
  }

  displayOtherField(selectedSoftware) {
    this.setState({
      displayOtherField: selectedSoftware == 6
    });
  }

  displayOtherFutureField(willChange) {
    this.setState({
      displayOtherFutureField: willChange == true
    });
  }

  renderOtherField() {
    return (
      <div className="form-group">
        <label className="label">Nom du logiciel</label>
        <input name="softwareOther" type="text" placeholder="Nom du logiciel" className={"textbox textbox-full textbox-program-"+Config.program.style}
          onChange={this.handleChange} 
          defaultValue={this.state.softwareOther} />
        <span className="form-error">{this.errorFor("softwareOther")}</span>
      </div>
    )
  }

  renderOtherFutureField() {
    return (
        <div className="form-group">
          <label className="label">Nom du futur logiciel</label>
          <input name="softwareOtherFuture" type="text" placeholder="Nom du futur logiciel" className={"textbox textbox-full textbox-program-"+Config.program.style}
                 onChange={this.handleChange}
                 defaultValue={this.state.softwareOtherFuture} />
          <span className="form-error">{this.errorFor("softwareOtherFuture")}</span>
        </div>
    )
  }

  render() {
    const softwares = this.state.softwares.map(
      (soft) => this.renderSoftwareView(soft)
    );

    return (
      <fieldset className="form-fieldset" id={this.props.id}>
        <legend className="form-fieldset-legend">Votre logiciel informatique</legend>
        { softwares }
        <div>
          <span className="form-error">{this.errorFor("selectedSoftware")}</span>
        </div>
        { this.state.displayOtherField ? this.renderOtherField() : <div></div> }


      </fieldset>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Forms/SoftwareChoice.js